import { ChangeEvent } from "react";

export const formatMoneyValue = (value: number) => {
  if (!value) return "R$ 0,00";

  const isDecimal = value % 1 !== 0;

  const adjustedValue = isDecimal ? value : value / 100;

  return addMoneySimbols(adjustedValue);
};

export const addMoneySimbols = (value: number | undefined | null) => {
  if (value === undefined || value === null || isNaN(value)) {
    return "R$ 0,00";
  }

  const formattedValue = value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return formattedValue;
};

export const addMoneySimbolsCents = (value: number | string | undefined) => {
  if (value === undefined || value === null) {
    return "R$ 0,00";
  }

  const numericValue =
    typeof value === "string" ? parseFloat(value) || 0 : value;

  if (isNaN(numericValue)) {
    return "R$ 0,00";
  }

  const valueInReais = numericValue / 100;
  return valueInReais.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export const moneyMask = (e: ChangeEvent<HTMLInputElement>) => {
  const _value = Number(e?.currentTarget?.value.replace(/\D/g, "") || 0);
  const value = formatMoneyValue(_value);
  e.target.value = value;
};
